import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import {Typography, VerticalSpacer} from 'epic-ue-ui';
import {Field} from 'react-final-form';
import {withLocalization} from '@epic-core/localization';

import {required} from '../jobForm.utils';
import InputValidationErrorMsg from '../formElements/inputFields/InputValidationErrorMsg';
import InputLabel from '../formElements/inputFields/InputLabel';

const Styled = styled.div``;

export interface DemographicQuestionsBlockProps {
    demographicQuestions?: {header; description; questions: any[]};
    formRenderProps: {
        handleSubmit;
        hasValidationErrors;
        submitFailed;
        form;
        submitSucceeded;
        values;
    };
    isInputsDisabled?: boolean;
    sectionRequiredLabel?: string;
    getMessage: (key: string) => string;
}

const DemographicQuestionsBlock = ({
    getMessage,
    demographicQuestions,
    formRenderProps,
    isInputsDisabled,
    sectionRequiredLabel
}: DemographicQuestionsBlockProps): JSX.Element => {
    return (
        <Styled className="demographic-questions">
            <Typography variant="h3"> {demographicQuestions?.header}</Typography>
            {demographicQuestions?.description && (
                <>
                    <div
                        className="field-description"
                        dangerouslySetInnerHTML={{
                            __html: demographicQuestions?.description
                        }}
                    />
                    <VerticalSpacer variant="heading" />
                </>
            )}

            <div className="demographic-questions-list">
                {demographicQuestions?.questions?.map((question, k) => {
                    return (
                        <div className="field-group" key={k}>
                            <Field name={`demographicQuestions.optionID${question?.id}`}>
                                {({meta}) => (
                                    <div>
                                        <InputLabel
                                            classnames={classNames({
                                                'validate-error':
                                                    !formRenderProps?.submitSucceeded &&
                                                    meta.error &&
                                                    meta.touched
                                            })}
                                            label={question?.label}
                                            required={question?.required}></InputLabel>
                                        {!formRenderProps?.submitSucceeded &&
                                            meta.error &&
                                            meta.touched && (
                                                <InputValidationErrorMsg
                                                    error={getMessage(meta.error)}
                                                    sectionRequiredLabel={sectionRequiredLabel}
                                                />
                                            )}
                                        <VerticalSpacer variant="eyebrow" />
                                        {question?.answer_options.map((field, m) => {
                                            return (
                                                <div key={`${k}-${m}`} className="radio-field">
                                                    <label>
                                                        <Field
                                                            name={`demographicQuestions.optionID${question?.id}`}
                                                            disabled={isInputsDisabled}
                                                            validate={
                                                                (question?.required && required) ||
                                                                undefined
                                                            }
                                                            component={'input'}
                                                            type="radio"
                                                            value={`answerID${field?.id}`}
                                                        />{' '}
                                                        {field?.label}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                        <VerticalSpacer variant="eyebrow" />
                                    </div>
                                )}
                            </Field>
                        </div>
                    );
                })}
            </div>
        </Styled>
    );
};

export default withLocalization(DemographicQuestionsBlock);
